import { assign } from 'lodash-es'
import { PeriodType, StatisticsType } from '@/api/base/enums'
import type { PageHeaderFilterArgs } from '@/api/home'
import dayjs from '@/utils/date-tools'
import type { CommissionPeriodDetail } from '@/api/commission'
import { PeriodBillConfirmStatus } from '@/types/enums'

const store = defineStore('globalSearch', () => {
  const searchData = ref<PageHeaderFilterArgs>({
    year: dayjs().year(),
    quarterly: 0,
    month: 0,
    periodType: PeriodType.Year,
    statisticsType: StatisticsType.Order,
    startTime: '',
    endTime: '',
  })

  // 佣金周期数据
  const commissionPeriodData = ref<CommissionPeriodDetail>({
    // 账期id
    periodId: '',
    // 周期时间
    period: '',
    // 账单状态
    status: PeriodBillConfirmStatus.Undefined,
  })

  function setSearchData(_searchData: Partial<PageHeaderFilterArgs>) {
    searchData.value = assign(searchData.value, _searchData)
  }

  // 设置佣金周期数据
  async function setCommissionPeriodData(_commissionPeriodData: CommissionPeriodDetail) {
    return new Promise((resolve) => {
      commissionPeriodData.value = assign(commissionPeriodData.value, _commissionPeriodData)
      resolve(true)
    })
  }

  return {
    searchData,
    commissionPeriodData,
    setSearchData,
    setCommissionPeriodData,
  }
}, {
  // https://prazdevs.github.io/pinia-plugin-persistedstate/zh/guide/config.html
  persist: {
    key: 'globalSearch',
    storage: sessionStorage,
    paths: ['searchData', 'commissionPeriodData'],
  },
})

export default store
